import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  thumbnail: '',
  processedThumbnail: '',
  fileName: '',
  youtubeUrl: '',
  youtubeStudioUrl: '',
  currentStep: 0,
  placement: false,
  videoId: null,
  videoUid: '',

  step1: {
    files: '',
  },

  step2: {},
  step3: {
    visibility: 'private',
    plan_date_and_time: null,
  },
};

const contentCreationSlice = createSlice({
  name: 'contentCreation',
  initialState,
  reducers: {
    setId: (state, action) => {
      state.step1.id = action.payload;
    },
    setVideoUid: (state, action) => {
      state.videoUid = action.payload;
    },

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },

    setFiles: (state, action) => {
      state.step1.files = action.payload;
    },

    setMadeForKids: (state, action) => {
      state.step1.madeForKids = action.payload;
    },

    setPlacement: (state, action) => {
      state.placement = action.payload;
    },
    setStatisticsDisplay: (state, action) => {
      state.statistics_display = action.payload;
    },
    setVisibility: (state, action) => {
      state.step3.visibility = action.payload;
    },
    setPlanDateAndTime: (state, action) => {
      state.step3.plan_date_and_time = action.payload;
    },
    setThumbnail: (state, action) => {
      state.thumbnail = action.payload;
    },
    setProcessedThumbnail: (state, action) => {
      state.processedThumbnail = action.payload;
    },
    setYoutubeUrl: (state, action) => {
      state.youtubeUrl = action.payload;
    },

    setYoutubeStudioUrl: (state, action) => {
      state.youtubeStudioUrl = action.payload;
    },
    setVideoId: (state, action) => {
      state.videoId = action.payload;
    },
    contentCreationFlow: () => initialState,
  },
});

export const {
  setId,
  setVideoUid,
  setCurrentStep,
  setFiles,
  setPlacement,
  setStatisticsDisplay,
  contentCreationFlow,
  setVisibility,
  setPlanDateAndTime,
  setThumbnail,
  setProcessedThumbnail,
  setYoutubeUrl,
  setYoutubeStudioUrl,
  setMadeForKids,
  setPoliciesApplicabletoVideo,
  setContentIdStatus,
  setPlacementDescription,
  setVideoId,
} = contentCreationSlice.actions;
export default contentCreationSlice.reducer;
